// @flow

import React, { Component } from "react";
import ReactDOM from "react-dom";
import Alert from "react-s-alert";
import { Icon } from "react-fa";

import TreeItemDir from "./TreeItemDir.jsx";
import App from "./App.jsx";

import { noop, takeDir, scroll } from "./utils.js";
import { fetch_png } from "./fetch_things.js";
import { T_CULTI } from "./codtype.js";

import type { T_Next, T_Item } from "./types.js";
import type { T_ImgFile } from "./Img.js";
import type { TreeItem } from "./TreeItem.js";

/* eslint-disable no-use-before-define */

export type T_OpenNextPng = (item_png: ?TreeItemPng) => void;

/* eslint-enable no-use-before-define */

type T_TreeItemPngProps = {
  node: T_Item,
  indent: number,
  parent_item: TreeItemDir,
  disabled: boolean,
  app: App,
};

type T_TreeItemPngState = {
  show_menu: boolean,
  hilight_fm: boolean, // highlight para señalar que se hizo click derecho sobre el item
  Loaded: boolean,
};

export default class TreeItemPng
  extends Component<T_TreeItemPngProps, T_TreeItemPngState>
  implements TreeItem
{
  click: (ev: SyntheticMouseEvent<*>) => void;
  rclick: (ev: SyntheticMouseEvent<*>) => void;

  constructor(props: T_TreeItemPngProps) {
    super(props);

    this.state = {
      show_menu: false,
      hilight_fm: false,
      Loaded: false,
    };

    this.click = this.click.bind(this);
    this.rclick = this.rclick.bind(this);
  }

  get_path(): string {
    return this.props.node.Path;
  }

  get_file(): string {
    return this.props.node.File;
  }

  is_MT(): boolean {
    return this.props.node.File.indexOf("Mapa_Tematico_") === 0;
  }

  open(next: T_Next = noop): void {
    if (
      this.state.Loaded ||
      (this.props.node.Unpub && !this.props.app.agrosat_user)
    ) {
      return next(false);
    }

    const { app } = this.props;

    fetch_png(app, this.props.node.Path, (response) => {
      if (typeof response === "string") {
        Alert.error(response);
        return next(false);
      }

      const img = (response: T_ImgFile),
        old_img = app.map_ui.map.last_img(takeDir(this.props.node.Path));

      if (img.img_filepath.indexOf("Mapa_Tematico_") !== -1) {
        img.nodeUrl = `${img.nodeUrl}&refresh=${Math.random() * 10000000000}`;
      }

      if (
        app.dev_mode &&
        app.use_color_brewer &&
        (img.has_lyrs || img.lyr != null || img.esc.lyrPath !== "")
      ) {
        img.nodeUrl = img.nodeUrl + app.esc_url_params(); // LAS ESCALAS LYR DEL EDI NO LAS DETECTA fetch_png, SINO QUE IMgScale

        if (img.esc.lyrPath !== "") {
          img.nodeUrl = `${img.nodeUrl}&lyr_path=${img.esc.lyrPath}`;
        }
      }

      const finale = () => {
        this.setState({ Loaded: true }, () => next(true));
      };

      const end = () => {
        if (old_img != null) {
          const item_png = app.get_item_png(old_img.obj.img_filepath);

          if (item_png != null) {
            const have_stats =
              app.toolbar != null && app.toolbar.state.stats != null;

            item_png.close(() => {
              app.map_ui.show_img(img, () => {
                if (have_stats && app.toolbar != null) {
                  app.toolbar.change_image_stats(img.img_filepath, finale);
                } else {
                  finale();
                }
              });
            });
          }
        } else {
          app.map_ui.show_img(img, finale);
        }
      };

      const item_culti = this.props.parent_item.shps.find(
        (ishp) => ishp.props.node.Cod === T_CULTI
      );

      if (item_culti && !app.map_ui.map.is_loaded(item_culti.props.node.Path)) {
        if (item_culti != null) {
          item_culti.toggle(end);
        }
      } else if (
        app.toolbar != null &&
        item_culti != null &&
        app.toolbar.state.culti !== item_culti.props.node.Path
      ) {
        const culti = item_culti.props.node;

        app.map_ui.change_culti(culti.Path, end, false, true);
      } else {
        end();
      }
    });
  }

  close(next: T_Next = noop): void {
    if (!this.state.Loaded) {
      return next(false);
    }

    this.props.app.map_ui.close_img(this.props.node.Path, () => {
      this.setState({ Loaded: false }, () => next(true));
    });
  }

  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }

    if (!this.state.Loaded) {
      this.open(next);
    } else {
      this.close(next);
    }
  }

  reload(next: T_Next = noop): void {
    // NOTE: si no está cargado, lo abre.
    if (this.state.Loaded) {
      this.close(() => {
        this.open(next);
      });
    } else {
      this.open(next);
    }
  }

  click = (ev: SyntheticMouseEvent<*>): void => {
    ev.stopPropagation();

    if (
      this.props.app.toolbar &&
      !!this.props.app.toolbar.state.show_tabla_oport
    ) {
      this.props.app.toolbar.setState({ show_tabla_oport: false });
    }

    if (ev.button === 0) {
      if (this.props.node.Unpub && !this.props.app.agrosat_user) {
        Alert.error("El mapa aún no ha sido publicado por Agrosat.");
      } else {
        this.toggle();
      }
    }
  };

  rclick = (ev: SyntheticMouseEvent<*>): void => {
    const { app } = this.props;

    if (app.can_admin_file(this.props.node)) {
      app.setState(
        {
          tree_item_menu: {
            px: ev.pageX,
            py: ev.pageY,
            node: this.props.node,
          },
        },
        () => {
          this.setState({ hilight_fm: true });
        }
      );
    }
  };

  refresh(next: T_Next = noop): void {
    const Loaded = this.props.app.map_ui.map.is_loaded(this.props.node.Path);

    if (Loaded !== this.state.Loaded) {
      this.setState({ Loaded }, () => next(true));
    } else {
      next(false);
    }
  }

  scroll(): void {
    scroll(ReactDOM.findDOMNode(this));
  }

  unclick(): void {
    if (this.state.Loaded) {
      this.setState({ Loaded: false });
    }
  }

  render() {
    const { Loaded } = this.state,
      lb_style = {
        fontWeight: Loaded ? "bold" : "normal",
        border: "0",
        paddingRight: 0,
        paddingLeft: 0,
        color: "black",
      },
      indent = { marginLeft: 15 * this.props.indent },
      tooltip =
        this.props.node.Unpub && this.props.node.Days
          ? { title: `En revisión desde hace ${this.props.node.Days} días` }
          : {};

    if (this.props.node.Unpub) {
      lb_style.color = "red";
    }

    if (this.state.hilight_fm) {
      lb_style.border = "1px solid red";
      lb_style.paddingRight = 3;
      lb_style.paddingLeft = 3;
    }

    return (
      <div>
        <div
          style={indent}
          className="treeItem"
          onClick={this.click}
          onContextMenu={this.rclick}
          {...tooltip}
        >
          <Icon
            name={
              this.props.node.Unpub && !this.props.app.agrosat_user
                ? "frown-o"
                : Loaded
                ? "check-square-o"
                : "square-o"
            }
          />

          <span style={lb_style} className="notranslate">
            {this.props.node.label}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemPng.jsx